import { IsBoolean } from 'class-validator';

import createDocumentResource from 'src/actions/shared/createDocumentResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';

export class CustomChannelsConfig {
  @IsBoolean()
  enabled: boolean;
}

const customChannelsConfigurationResource = createDocumentResource<CustomChannelsConfig>({
  name: 'customChannelsConfiguration',
  endpoint: 'v1/orgs/:orgId/configuration/customchannels',
  type: CustomChannelsConfig,
  observerCreator: emptyObserverCreator,
});

export default customChannelsConfigurationResource;
